import React, { useState } from "react";
import Slider from "react-slick";
import heroimage1 from "../assets/heroimage1.jpg";
import {
    ArrowRight,
    ChevronLeft,
    ChevronRight,
    Hospital,
    Search,
} from "lucide-react";

import { useNavigate } from "react-router-dom";
import Drsaurabhsir from "../assets/doctors/saurabhsir.jpeg";
import Dramitsir from "../assets/doctors/amitsir.jpeg";
import Drkavita from "../assets/doctors/kavita.jpeg";
import Drshivam from "../assets/doctors/shivam.jpeg";

import DrAlokRai from "../assets/doctors/DrAlokRai.jpg";
import DrChanchalKumar from "../assets/doctors/DrChanchalKumar.jpg";
import DrSKBhariya from "../assets/doctors/DrSKBhariya.jpg";
import DrSanjayYadav from "../assets/doctors/DrSanjayYadav.jpg";
import DrShashi from "../assets/doctors/DrShashi.jpg";
import DrShubhamSrivastava from "../assets/doctors/DrShubhamSrivastava.jpg";
import DrSudipta from "../assets/doctors/DrSudipta.jpg";
import DrUmeshKumar from "../assets/doctors/DrUmeshKumar.jpg";
import DrVaibhav from "../assets/doctors/DrVaibhav.jpg";
import DrVivekKatiyar from "../assets/doctors/DrVivekKatiyar.jpg";
import ProfNKAgarwal from "../assets/doctors/ProfNKAgarwal.jpg";
import ProfRajeshMeena from "../assets/doctors/ProfRajeshMeena.jpg";
import DrBirju from "../assets/doctors/DrBirju.jpg";
import DrAbhijeet from "../assets/doctors/DrAbhijeetKunwar.jpg";

const doctors = [
    // 🟦 ORTHOPEDICS
    {
      id: 1,
      name: "Prof. Saurabh Singh",
      designation: "MS, MCH (Orthopedics)",
      description: "Professor In-charge, Trauma Centre, IMS, BHU & Professor Department of Orthopedics",
      imageUrl: Drsaurabhsir,
      rating: 4.9,
      experience: "15+ years",
      hospital: "Trauma Centre, IMS BHU",
      specialty: "Orthopedics",
      nextAvailable: "Today, 4:00 PM",
    },
    {
      id: 2,
      name: "Prof. Amit Rastogi",
      designation: "MS (Orthopedics)",
      description: "Renowned orthopedic surgeon specializing in joint replacements and sports injuries.",
      imageUrl: Dramitsir,
      rating: 4.8,
      experience: "12+ years",
      hospital: "Trauma Centre, IMS BHU",
      specialty: "Orthopedics",
      nextAvailable: "Tomorrow, 10:00 AM",
    },
    {
      id: 3,
      name: "Prof. Shivam Sinha",
      designation: "MS (Orthopedics)",
      description: "Expert in trauma surgery and orthopedic rehabilitation techniques.",
      imageUrl: Drshivam,
      rating: 4.7,
      experience: "10+ years",
      hospital: "Trauma Centre, IMS BHU",
      specialty: "Orthopedics",
      nextAvailable: "Today, 6:00 PM",
    },
    {
      id: 4,
      name: "Dr. Alok Rai",
      designation: "MS (Orthopedics)",
      description: "Orthopedic surgeon with focus on fracture management and bone disorders.",
      imageUrl: DrAlokRai,
      rating: 4.6,
      experience: "8+ years",
      hospital: "Trauma Centre, IMS BHU",
      specialty: "Orthopedics",
      nextAvailable: "Tomorrow, 11:00 AM",
    },
    {
      id: 5,
      name: "Dr. Chanchal Kumar Singh",
      designation: "MS (Orthopedics)",
      description: "Specializes in pediatric orthopedics and congenital deformities.",
      imageUrl: DrChanchalKumar,
      rating: 4.5,
      experience: "6+ years",
      hospital: "Trauma Centre, IMS BHU",
      specialty: "Orthopedics",
      nextAvailable: "Today, 1:00 PM",
    },
    {
      id: 6,
      name: "Dr. Sanjay Yadav",
      designation: "MS (Orthopedics)",
      description: "Specialist in orthopedic trauma and complex bone surgeries.",
      imageUrl: DrSanjayYadav,
      rating: 4.8,
      experience: "12+ years",
      hospital: "Trauma Centre, IMS BHU",
      specialty: "Orthopedics",
      nextAvailable: "Tomorrow, 9:00 AM",
    },
    {
      id: 7,
      name: "Dr. Subham Srivastava",
      designation: "MS (Orthopedics)",
      description: "Focused on joint disorders, arthritis, and orthopedic pain management.",
      imageUrl: DrShubhamSrivastava,
      rating: 4.6,
      experience: "7+ years",
      hospital: "Trauma Centre, IMS BHU",
      specialty: "Orthopedics",
      nextAvailable: "Tomorrow, 1:30 PM",
    },
    {
      id: 8,
      name: "Dr. Abhijeet Kunwar",
      designation: "MS(Orthopedics)",
      description: "Focused on joint disorders, arthritis, and orthopedic pain management.",
      imageUrl: DrAbhijeet,
      rating: 4.6,
      experience: "7+ years",
      hospital: "Trauma Centre, IMS BHU",
      specialty: "Orthopedics",
      nextAvailable: "Tomorrow, 1:30 PM",
    },
    {
      id: 9,
      name: "Dr. Birju Majhi",
      designation: "MS(Orthopedics)",
      description: "Focused on joint disorders, arthritis, and orthopedic pain management.",
      imageUrl: DrBirju,
      rating: 4.6,
      experience: "7+ years",
      hospital: "Trauma Centre, IMS BHU",
      specialty: "Orthopedics",
      nextAvailable: "Tomorrow, 1:30 PM",
    },
  
    // 🟩 PLASTIC SURGERY
    {
      id: 10,
      name: "Dr. Shashi Prakash Mishra",
      designation: "MS (Plastic Surgery)",
      description: "Plastic and reconstructive surgeon with expertise in burns and cosmetic surgery.",
      imageUrl: DrShashi,
      rating: 4.7,
      experience: "14+ years",
      hospital: "Trauma Centre, IMS BHU",
      specialty: "Plastic Surgery",
      nextAvailable: "Today, 4:30 PM",
    },
    {
      id: 11,
      name: "Dr. Sudipta Bera",
      designation: "MS (Plastic Surgery)",
      description: "Plastic surgeon with focus on craniofacial surgery and aesthetic procedures.",
      imageUrl: DrSudipta,
      rating: 4.8,
      experience: "9+ years",
      hospital: "Trauma Centre, IMS BHU",
      specialty: "Plastic Surgery",
      nextAvailable: "Today, 2:00 PM",
    },
    {
      id: 12,
      name: "Dr. Umesh Kumar",
      designation: "MS (Plastic Surgery)",
      description: "Expert in reconstructive microsurgery and cosmetic treatments.",
      imageUrl: DrUmeshKumar,
      rating: 4.9,
      experience: "16+ years",
      hospital: "Trauma Centre, IMS BHU",
      specialty: "Plastic Surgery",
      nextAvailable: "Tomorrow, 5:00 PM",
    },
    {
      id: 13,
      name: "Dr. Vaibhav Jain",
      designation: "MS (Plastic Surgery)",
      description: "Plastic surgeon with specialization in hand surgery and maxillofacial trauma.",
      imageUrl: DrVaibhav,
      rating: 4.7,
      experience: "12+ years",
      hospital: "Trauma Centre, IMS BHU",
      specialty: "Plastic Surgery",
      nextAvailable: "Today, 11:00 AM",
    },
    {
      id: 14,
      name: "Prof. N.K.Agarwal",
      designation: "MS (Plastic Surgery)",
      description: "Senior plastic surgeon experienced in complex reconstructions and burns.",
      imageUrl: ProfNKAgarwal,
      rating: 4.8,
      experience: "10+ years",
      hospital: "Trauma Centre, IMS BHU",
      specialty: "Plastic Surgery",
      nextAvailable: "Tomorrow, 9:30 AM",
    },
  
    // ⚠️ TRAUMA SURGERY
    {
      id: 17,
      name: "Dr. S.K.Bhartiya",
      designation: "MS (General Surgery)",
      description: "General surgeon skilled in laparoscopic and gastrointestinal surgeries.",
      imageUrl: DrSKBhariya,
      rating: 4.7,
      experience: "10+ years",
      hospital: "Trauma Centre, IMS BHU",
      specialty: "Trauma Surgery",  // Changed from "Surgery" to "Trauma Surgery"
      nextAvailable: "Today, 3:00 PM",
    },
    {
      id: 18,
      name: "Dr. Vivek Katiyar",
      designation: "MS (General Surgery)",
      description: "ENT and head-neck specialist with expertise in sinus and vocal cord surgeries.",
      imageUrl: DrVivekKatiyar,
      rating: 4.5,
      experience: "8+ years",
      hospital: "Trauma Centre, IMS BHU",
      specialty: "Trauma Surgery",  // Changed from "ENT" to "Trauma Surgery"
      nextAvailable: "Tomorrow, 10:00 AM",
    },
    
    // ⚠️ OTHERS
    {
      id: 15,
      name: "Prof. Rajesh Meena",
      designation: "MD Anesthesia, PDCC",
      description: "Senior anesthesiologist with expertise in cardiac anesthesia and pain management.",
      imageUrl: ProfRajeshMeena,
      rating: 4.9,
      experience: "18+ years",
      hospital: "Trauma Centre, IMS BHU",
      specialty: "Cardiology",
      nextAvailable: "Tomorrow, 2:00 PM",
    },
    {
      id: 16,
      name: "Dr. Kavita Meena",
      designation: "MD Anesthesia, PDCC",
      description: "Neuro-anesthesiologist specialized in critical care and neuro-intervention support.",
      imageUrl: Drkavita,
      rating: 4.8,
      experience: "14+ years",
      hospital: "Trauma Centre, IMS BHU",
      specialty: "Neurology",
      nextAvailable: "Today, 5:30 PM",
    },
  ];

const images = [heroimage1, heroimage1, heroimage1];

const ImageSlider = () => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [doctorName, setDoctorName] = useState("");
    const [selectedDepartment, setSelectedDepartment] = useState(""); // Added state for department
    const [filteredDoctors, setFilteredDoctors] = useState([]);
    const navigate = useNavigate();

    // Only show specific departments in the dropdown
    const departments = ["All Departments", "Orthopedics", "Plastic Surgery", "Trauma Surgery"];

    const NextArrow = ({ onClick }) => (
        <button
            onClick={onClick}
            className="absolute z-10 p-2 transition-all duration-300 transform -translate-y-1/2 bg-white/60 hover:bg-white/80 rounded-full top-1/2 right-4"
            aria-label="Next slide"
        >
            <ChevronRight className="w-5 h-5 text-gray-800" />
        </button>
    );

    const PrevArrow = ({ onClick }) => (
        <button
            onClick={onClick}
            className="absolute z-10 p-2 transition-all duration-300 transform -translate-y-1/2 bg-white/60 hover:bg-white/80 rounded-full top-1/2 left-4"
            aria-label="Previous slide"
        >
            <ChevronLeft className="w-5 h-5 text-gray-800" />
        </button>
    );

    const settings = {
        dots: true,
        dotsClass: "slick-dots custom-dots",
        infinite: true,
        speed: 800,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: false,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        beforeChange: (current, next) => setCurrentSlide(next),
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: true,
                    dots: true,
                }
            },
        ],
        appendDots: (dots) => (
            <div>
                <ul className="absolute left-0 right-0 flex items-center justify-center gap-2 bottom-4">
                    {dots}
                </ul>
            </div>
        ),
        customPaging: (i) => (
            <button
                className={`w-2 h-2 rounded-full transition-all duration-300 ${
                    i === currentSlide ? "bg-white scale-125" : "bg-white/50"
                }`}
                aria-label={`Go to slide ${i + 1}`}
            />
        ),
    };

    const handleSearch = (e) => {
        e.preventDefault();
        
        // Start with all doctors
        let filtered = doctors;
        
        // Filter by selected department if one is selected (not "All Departments")
        if (selectedDepartment && selectedDepartment !== "All Departments") {
            filtered = filtered.filter(doc => 
                doc.specialty === selectedDepartment
            );
        }
        
        // Further filter by name if a name is entered
        if (doctorName.trim() !== "") {
            filtered = filtered.filter(doc =>
                doc.name.toLowerCase().includes(doctorName.toLowerCase())
            );
        }
        
        setFilteredDoctors(filtered);
    };

    const handleViewProfile = (doctorId) => {
        navigate(`/doctor-profile/${doctorId}`);
    };

    const handleBookAppointment = (doctorId) => {
        navigate(`/book-appointment/${doctorId}`);
    };

    return (
        <div className="w-full">
            <div className="relative overflow-hidden">
                <div className="slider-container w-full">
                    <Slider {...settings}>
                        {images.map((src, index) => (
                            <div key={index} className="relative">
                                <div className="w-full aspect-[16/10] sm:aspect-[16/9] md:aspect-[21/9] lg:aspect-[5/2] bg-black flex items-center justify-center overflow-hidden">
                                    <img
                                        src={src}
                                        alt={`slide-${index}`}
                                        className="w-full h-full object-cover scale-100"
                                    />
                                </div>

                                {/* Modified search panel for better mobile display */}
                                {/* <div className="absolute bottom-12 sm:bottom-8 left-0 right-0 w-[94%] mx-auto sm:left-8 sm:w-[90%] md:w-[70%] max-w-4xl p-3 sm:p-6 md:p-8 bg-white/70 backdrop-blur-md rounded-xl">
                                    <div className="mb-2 sm:mb-4">
                                        <p className="text-xs sm:text-sm text-gray-700 font-medium">
                                            Book Your Appointment
                                        </p>
                                        <h2 className="text-xl sm:text-3xl md:text-4xl font-bold text-gray-900">
                                            Let's Find a Doctor
                                        </h2>
                                    </div>

                                    <form
                                        onSubmit={handleSearch}
                                        className="grid grid-cols-1 gap-2 sm:gap-4 items-center"
                                    >
                                        <div className="flex items-center px-3 py-2 bg-white rounded-lg">
                                            <Hospital className="w-4 h-4 sm:w-5 sm:h-5 mr-2 text-teal-600" />
                                            <select 
                                                className="w-full text-sm sm:text-base text-gray-800 bg-transparent focus:outline-none"
                                                value={selectedDepartment}
                                                onChange={(e) => setSelectedDepartment(e.target.value)}
                                            >
                                                {departments.map((dept, index) => (
                                                    <option key={index} value={dept}>
                                                        {dept}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="flex items-center px-3 py-2 bg-white rounded-lg">
                                            <Search className="w-4 h-4 sm:w-5 sm:h-5 mr-2 text-teal-600" />
                                            <input
                                                type="text"
                                                placeholder="Enter Doctor Name"
                                                value={doctorName}
                                                onChange={(e) => setDoctorName(e.target.value)}
                                                className="w-full text-sm sm:text-base bg-transparent focus:outline-none"
                                            />
                                        </div>

                                        <button
                                            type="submit"
                                            className="flex items-center justify-center px-4 sm:px-6 py-2 font-semibold text-sm sm:text-base text-white transition-all rounded-lg bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 focus:outline-none"
                                        >
                                            Search
                                            <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5 ml-2" />
                                        </button>
                                    </form>

                                    <div className="flex flex-col mt-2 sm:mt-4 text-xs sm:text-sm">
                                        <p className="text-gray-700">
                                            Need help in booking?{' '}
                                            <span className="font-semibold text-teal-700">
                                                +91 0542–2366073
                                            </span>
                                        </p>
                                    </div>
                                </div> */}
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>

            {/* Doctor Cards - Updated to show count of results */}
            {filteredDoctors.length > 0 ? (
                <div className="max-w-screen-xl mx-auto px-4 pb-10 mt-6 sm:mt-10">
                    <div className="mb-4 flex justify-between items-center">
                        <h2 className="text-lg sm:text-xl font-semibold text-gray-800">
                            Found {filteredDoctors.length} doctor{filteredDoctors.length !== 1 ? 's' : ''}
                        </h2>
                    </div>
                    
                    <div className="grid grid-cols-1 gap-4 sm:gap-6 md:grid-cols-2">
                        {filteredDoctors.map((doctor) => (
                            <div
                                key={doctor.id}
                                className="flex p-3 sm:p-4 transition bg-white border border-gray-100 rounded-xl hover:border-gray-200"
                            >
                                <div className="flex-shrink-0 w-20 h-20 mr-3 sm:w-24 sm:h-24 md:w-28 md:h-28 sm:mr-4">
                                    <img
                                        src={doctor.imageUrl}
                                        alt={doctor.name}
                                        className="object-cover w-full h-full rounded-lg"
                                    />
                                </div>
                                <div className="flex flex-col justify-between flex-grow">
                                    <div>
                                        <h3 className="text-sm sm:text-base md:text-lg font-semibold text-[#1B3C74]">
                                            {doctor.name}
                                        </h3>
                                        <p className="text-xs sm:text-sm text-[#1B3C74]/80 mt-1">
                                            {doctor.designation}
                                        </p>
                                        <div className="flex items-center mt-1">
                                            {/* <span className="text-xs text-teal-600 font-medium bg-teal-50 px-2 py-0.5 rounded-full">
                                                {doctor.specialty}
                                            </span> */}
                                        </div>
                                        <p className="mt-1 sm:mt-2 text-xs sm:text-sm text-gray-600 line-clamp-2 sm:line-clamp-none">
                                            {doctor.description}
                                        </p>
                                    </div>
                                    <div className="flex gap-2 mt-2 sm:mt-4">
                                        <button
                                            className="flex-1 border border-[#009DA5] text-[#009DA5] font-medium px-2 sm:px-3 py-1 sm:py-1.5 text-xs sm:text-sm rounded-md hover:bg-[#009DA5]/5 transition"
                                            onClick={() => handleViewProfile(doctor.id)}
                                        >
                                            View Profile
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            ) : filteredDoctors.length === 0 && (doctorName || selectedDepartment !== "") ? (
                <div className="max-w-screen-xl mx-auto px-4 py-10 text-center">
                    <p className="text-gray-600">No doctors found. Please try different search criteria.</p>
                </div>
            ) : null}

            {/* Updated slider styles for full-width and mobile responsiveness */}
            <style jsx>{`
                .slider-container {
                    width: 100%;
                    overflow: hidden;
                }
                
                .slider-container .slick-list {
                    overflow: visible;
                    width: 100% !important;
                }
                
                .slider-container .slick-slide {
                    transition: all 0.3s ease;
                }
                
                .slider-container .slick-slide > div {
                    margin: 0;
                    width: 100%;
                }
                
                .slider-container .slick-current {
                    z-index: 1;
                }
                
                /* Mobile specific styles */
                @media (max-width: 640px) {
                    .slider-container .slick-dots {
                        bottom: 3px !important;
                    }
                    
                    .slider-container .slick-arrow {
                        width: 30px !important;
                        height: 30px !important;
                        padding: 5px !important;
                    }
                    
                    .slider-container .slick-prev {
                        left: 5px !important;
                    }
                    
                    .slider-container .slick-next {
                        right: 5px !important;
                    }
                }
            `}</style>
        </div>
    );
};

export default ImageSlider;